module.exports = __webpack_public_path__ + "img/world-map-2.5569ac4a.png";